import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import HeaderHoverImage from '@pkg/assets/images/v2/pods/header_hover.png';

import { GroupHeaderButton, GroupHeaderFollowerInfo, GroupName } from '../GroupHeader';
import { GroupHeaderDescription } from '../GroupHeader/GroupHeaderDescription';
import { GroupHeaderImage } from '../GroupHeader/GroupHeaderImage';
import { GroupHeaderMembers } from '../GroupHeader/GroupHeaderMembers';

export const Wrapper = styled.div`
    width: 100%;
    position: relative;
    padding: 0 20px 4px 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 0 0 23px 0;
    }
`;

export const Inside = styled.div`
    width: 100%;
    position: relative;
    z-index: 1;
`;

export const HoverBackground = styled.div<{ $hovering: boolean }>`
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    background-image: url(${HeaderHoverImage});
    background-size: contain;
    background-position: bottom center;
    background-repeat: no-repeat;

    opacity: 0;
    transition: opacity 300ms ease;

    ${({ $hovering }) =>
        $hovering
            ? css`
                  opacity: 1;
              `
            : null}

    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;

export const ButtonWrapper = styled.div`
    &&& {
        position: absolute;
        top: 6px;
        display: flex;
        flex-direction: row;
        right: 0;
        > :nth-child(2) {
            margin-left: 8px;
        }
        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            top: 0;
        }
    }
`;

export const StyledLink = styled(Link)`
    display: inline-grid;
    grid-template-columns: 32px auto;
    gap: 10px;
    cursor: pointer;
    min-width: 40%;
    width: 100%;
    padding-right: 62px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        grid-template-columns: min-content auto;
        width: auto;
        padding-right: 0;
        gap: 10px 30px;
    }
`;

export const StyledImage = styled(GroupHeaderImage)`
    &&& {
        grid-column: 1 / span 1;
        grid-row: 1;
        display: flex;
        align-items: center;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            grid-row: 1 / span 3;
            grid-column: 1 / span 1;
        }
    }
`;

export const NameContainer = styled.div`
    &&& {
        grid-row: 1;
        grid-column: 2 / span 1;
        display: flex;
        align-items: center;
        gap: 4px;

        @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
            grid-column: 2;
            grid-row: 1;
            font-size: 2.25rem;
            line-height: 1.2;
        }
    }
`;

export const StyledName = styled(GroupName)`
    &&& {
        @media (min-width: ${({ theme }) => theme.breakpoints.desktopSmall}) {
            font-size: 2.25rem;
            line-height: 1.2;
        }
    }
`;

export const HoverContainer = styled.div`
    position: relative;
`;

export const Underline = styled.div<{ $hovering: boolean }>`
    height: 2px;
    width: 100%;
    background-color: #fff;
    position: absolute;
    top: 100%;
    left: 1px;

    transform: scaleX(0);
    transform-origin: right 0;
    transition: transform 300ms ease;

    ${({ $hovering }) =>
        $hovering
            ? css`
                  transform: scaleX(1);
                  transform-origin: 0 0;
              `
            : null}

    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: block;
    }
`;

export const Arrow = styled.div<{ $hovering: boolean }>`
    width: 30px;
    height: 30px;
    background-color: #fff;
    border-radius: 100%;

    transition: transform 300ms ease;

    align-items: center;
    justify-content: center;
    color: #090719;

    margin-left: 4px;

    transform: scale(0);
    transform-origin: center center;
    transition: transform 300ms ease;

    align-self: flex-end;

    svg {
        width: 14.61px;
        height: 16px;
        opacity: 0;
        transform: translateX(-6px);
        transition:
            transform 300ms ease,
            opacity 300ms ease;
    }

    ${({ $hovering }) =>
        $hovering
            ? css`
                  transform: scale(1);
                  transition-delay: 200ms;

                  svg {
                      opacity: 1;
                      transform: translateX(0);
                      transition-delay: 400ms;
                  }
              `
            : null}

    display: none;
    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: flex;
    }
`;

export const StyledDescription = styled(GroupHeaderDescription)`
    &&& {
        grid-column: 1/-1;
        padding-left: 1px;
        font-size: 14px;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            grid-column: 2 / -1;
            font-size: 16px;
        }
    }
`;

export const StyledFollowerInfo = styled(GroupHeaderFollowerInfo)`
    &&& {
        grid-column: 1/-1;
        display: flex;
        align-items: center;
        gap: 7px;
        font-weight: 400;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            grid-column: 2 / -1;
        }
    }
`;

export const StyledMembers = styled(GroupHeaderMembers)`
    &&& {
        display: flex;
        flex-wrap: wrap;
        gap: 7px;

        margin-top: 10px;
        padding-left: 0;

        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            padding-left: 120px;
        }
    }
`;
export const StyledGroupHeaderButton = styled(GroupHeaderButton)`
    &&& {
        padding: 7px 15px;
        height: 24px;
        font-size: 10px;
        line-height: 10px;
        @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
            height: 40px;
            font-size: 14px;
            line-height: 100%;
            padding: 13px 40px;
        }
    }
`;

export const ViewButton = styled(Link)`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    padding: 7px 15px;
    height: 24px;
    font-size: 10px;
    line-height: 10px;
    cursor: pointer;
    border: none;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    background: rgba(255, 255, 255, 0.1);

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        display: none;
    }
`;
